// First-touch acquisition attribution. Reads `?src=…` from the URL on any page
// load, stores it in localStorage so it survives navigation, and hands it back
// at buyer registration. Written to only once — the first source wins.

const KEY = "cs_acquisition_source";
const VALID = new Set([
  "Direct", "WhatsApp", "Instagram", "Facebook", "Google", "Influencer",
  "Organic", "Vendor referral", "CityShor audience", "Referral",
  "Paid advertisement", "Exhibition campaign", "Other",
]);

function normalise(v) {
  if (!v) return null;
  const t = String(v).trim().toLowerCase();
  for (const opt of VALID) if (opt.toLowerCase() === t) return opt;
  // Common aliases
  if (t === "wa" || t === "whatsapp-share") return "WhatsApp";
  if (t === "ref" || t === "referral") return "Referral";
  if (t === "ads" || t === "ad" || t === "paid") return "Paid advertisement";
  return "Other";
}

export function captureFromUrl() {
  try {
    const p = new URLSearchParams(window.location.search);
    const raw = p.get("src") || p.get("utm_source");
    const norm = normalise(raw);
    if (!norm) return;
    if (localStorage.getItem(KEY)) return; // first-touch wins
    localStorage.setItem(KEY, norm);
  } catch { /* ignore */ }
}

export function getSource() {
  try { return localStorage.getItem(KEY) || "Direct"; } catch { return "Direct"; }
}
